<script>
import UpdateRating from "./UpdateRating";
import Feedbacks from "./Feedbacks/Index";
import ratingMixin from "@/mixins/ratingMixin";

export default {
  mixins: [ratingMixin],
  props: {
    professional: {
      type: Object,
      required: true
    }
  },

  components: {
    UpdateRating,
    Feedbacks
  },

  data() {
    return {
      updateRating: false
    };
  }
};
</script>

<template>
  <div>
    <v-layout class="header" row justify-space-between align-center>
      <div class="title">
        MÉDIA DE AVALIAÇÕES
        {{ professional.rating | intToRating }}
        <div class="bg-rating big">
          <div
            class="stars"
            :style="`width: ${professional.rating / 100}%`"
          ></div>
        </div>
      </div>

      <v-btn color="primary" @click="updateRating = true">atualizar nota</v-btn>
    </v-layout>

    <feedbacks :professional_id="professional.id" />

    <update-rating
      v-if="updateRating"
      :professional="professional"
      @close="updateRating = false"
      @refresh="$emit('refresh')"
    />
  </div>
</template>

<style scoped>
.header {
  padding-bottom: 10px;
  border-bottom: 1px solid #efefef;
  margin-bottom: 30px;
}

.title {
  display: flex;
  flex-direction: column;
  font-size: 30px;
  text-align: center;
  margin-top: 20px;
}

.content-ratings {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.bg-rating {
  background: url("https://res.cloudinary.com/joaofnds/image/upload/v1548201143/email%20donamaid/estrela_contorno-01.png")
    no-repeat;
  width: 69px;
  height: 11px;
}

.stars {
  background: url("https://res.cloudinary.com/joaofnds/image/upload/v1548201143/email%20donamaid/estrela_color-01.png")
    no-repeat;
  max-width: 100%;
  height: 100%;
  background-size: auto 100%;
}

.bg-rating.big {
  background-size: 100% 100%;
  width: 138px;
  height: 22px;
}

.rating {
  display: flex;
  flex-direction: row;
  width: calc(50% - 10px);
  margin-bottom: 20px;
}

.rating:nth-child(odd) {
  margin-right: 10px;
}

.rating:nth-child(even) {
  margin-left: 10px;
}

.rating img {
  width: 50px;
  height: 50px;
  border: 2px solid var(--purple);
  border-radius: 100%;
  margin-right: 15px;
}

.content-rating {
  display: flex;
  flex-direction: column;
}

.content-rating .top {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
}

.content-rating p {
  text-align: justify;
  font-size: 13px;
  margin-top: 0;
}

@media (max-width: 768px) {
  .rating {
    width: 100%;
  }

  .title {
    font-size: 20px;
  }
}
@media (max-width: 480px) {
  .rating,
  .content-rating .top {
    flex-direction: column;
    align-items: center;
  }

  .rating {
    margin-right: 0 !important;
  }

  .content-rating p {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Tabs/Ratings/Index.vue